import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  min-height: 350px;
  max-width: 600px;
  margin: 40px auto;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const IconWrapper = styled.div`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.palette.error || '#d32f2f'};
  font-size: 3rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.palette.black};
`;

export const Message = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.grey60};
  max-width: 500px;
  line-height: 1.5;
`;
